import {
  RoomCredentialSchema,
  type RoomCredential,
} from "../game/types";

const STORAGE_KEY = "pusoy-dos.room-credential";
const NAME_KEY = "pusoy-dos.player-name";

export function loadCredential(): RoomCredential | null {
  const value = window.localStorage.getItem(STORAGE_KEY);
  if (!value) return null;

  try {
    const parsed = RoomCredentialSchema.safeParse(JSON.parse(value));
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

export function saveCredential(credential: RoomCredential): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(credential));
  window.localStorage.setItem(NAME_KEY, credential.playerName);
}

export function clearCredential(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}

export function loadPlayerName(): string {
  return window.localStorage.getItem(NAME_KEY) ?? "";
}
